import { Home, Compass, Layers, User, PlusCircle } from 'lucide-react';
import { useApp } from '../lib/AppContext';

export default function BottomNav() {
  const { currentScreen, navigateTo, isLoadingData } = useApp();

  const tabs = [
    { id: 'home', label: 'Home', icon: Home },
    { id: 'explore', label: 'Explore', icon: Compass },
    { id: 'saved', label: 'Collection', icon: Layers },
    { id: 'contribute', label: 'Contribute', icon: PlusCircle },
    { id: 'profile', label: 'Profile', icon: User },
  ];

  const contributeScreens = ['contribute', 'submit-song', 'submission-success'];

  if (isLoadingData) {
    return null;
  }

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 bg-[#111111] border-t border-[#282828] bottom-nav"
      style={{
        paddingTop: '10px',
        paddingLeft: '8px',
        paddingRight: '8px',
        paddingBottom: 'calc(env(safe-area-inset-bottom, 0px) + 16px)',
        minHeight: '68px',
        maxHeight: '92px',
        zIndex: 200,
        position: 'fixed',
        transform: 'translateZ(0)',
        willChange: 'transform',
      }}
    >
      <div className="flex items-center justify-around h-full">
        {tabs.map(tab => {
          const Icon = tab.icon;
          const isActive = tab.id === 'contribute'
            ? contributeScreens.includes(currentScreen)
            : currentScreen === tab.id;

          return (
            <button
              key={tab.id}
              className="flex flex-col items-center justify-center flex-1 active:scale-95 transition-transform"
              onClick={() => navigateTo(tab.id)}
              style={{
                minHeight: '48px',
                gap: '4px',
              }}
            >
              <Icon
                className={`w-5 h-5 ${
                  isActive ? 'text-[#40E0D0]' : 'text-[#808080]'
                }`}
                strokeWidth={2}
              />
              <span
                className={`text-[10px] font-medium ${
                  isActive ? 'text-[#40E0D0]' : 'text-[#808080]'
                }`}
              >
                {tab.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
